import React, { useState } from 'react';
import Layout from '../components/Layout';
import { api } from '../api';
import './ContactPage.css';

function ContactPage({ onLoginClick }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [lastMessageId, setLastMessageId] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      setError(null);
      const res = await api.submitContactForm({
        name: formData.name,
        email: formData.email,
        phone: formData.phone || undefined,
        subject: formData.subject,
        message: formData.message,
      });
      setLastMessageId(res.messageId ?? null);
      setSubmitted(true);
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (err) {
      setError(err.message || 'Could not send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout onLoginClick={onLoginClick}>
      <div className="contact-page">
        <section className="contact-hero">
          <div className="contact-hero-bg" />
          <div className="contact-hero-overlay" />
          <div className="contact-hero-content">
            <h1>Contact Us</h1>
            <p>We&apos;re here to help. Reach out anytime.</p>
          </div>
        </section>

        <section className="contact-main">
          <div className="contact-main-inner">
            <div className="contact-form-section">
              <h2>Send a Message</h2>
              {submitted ? (
                <div className="contact-success">
                  <p>
                    Thank you! Your message was sent to the FarmFleet team and appears in the
                    admin dispatch inbox.
                  </p>
                  {lastMessageId != null && (
                    <p className="contact-success-ref">Reference #{lastMessageId}</p>
                  )}
                  <button
                    type="button"
                    className="btn-submit contact-send-another"
                    onClick={() => {
                      setSubmitted(false);
                      setLastMessageId(null);
                    }}
                  >
                    Send another message
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  {error && (
                    <div className="contact-form-error" role="alert">
                      {error}
                    </div>
                  )}
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Your name"
                      disabled={submitting}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="your@email.com"
                      disabled={submitting}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+237 6 XX XX XX XX"
                      disabled={submitting}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      disabled={submitting}
                    >
                      <option value="">Select a topic</option>
                      <option value="transport">Transport Request</option>
                      <option value="partnership">Partnership Inquiry</option>
                      <option value="support">General Support</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={5}
                      placeholder="How can we help you?"
                      disabled={submitting}
                    />
                  </div>
                  <button type="submit" className="btn-submit" disabled={submitting}>
                    {submitting ? 'Sending…' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default ContactPage;
